// src/hooks/useArticleList.ts
import { useState, useEffect } from 'react';
import { apiPublicGet } from '../api';
import { ArticleListItem } from '../types/helpArticles';
import { prerenderedList, rememberList } from '../utils/prerenderedHelp';

/**
 * Fetches the public list of all help articles (slug, title, topic, meta). On a page
 * built with the list in its HTML (#1143) it starts from that and refreshes quietly.
 */
export function useArticleList(): { list: ArticleListItem[]; loading: boolean } {
  const [list, setList] = useState<ArticleListItem[]>(() => prerenderedList() ?? []);
  const [loading, setLoading] = useState(() => prerenderedList() === null);

  useEffect(() => {
    let cancelled = false;
    const seeded = prerenderedList();
    apiPublicGet('/articles')
      .then(async (res) => {
        const data = await res.body.json() as unknown as ArticleListItem[];
        // A reply that is not a list never replaces the built one.
        if (Array.isArray(data)) rememberList(data);
        if (!cancelled) setList(Array.isArray(data) ? data : seeded ?? []);
      })
      .catch((err) => { console.error('[useArticleList] fetch failed:', err); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { list, loading };
}
